import type { DataProvider } from 'react-admin';

/**
 * Seam for the react-admin data provider. No `<Resource>` is registered in
 * this wave (scaffold only, per plan B1) so none of these methods are
 * exercised yet; the typed API client in `src/api/client.ts` is the real,
 * independently usable contract client. Later waves (B2 onward) wire
 * concrete resources here, translating react-admin's `getList`/`getOne`
 * shape into `payApiClient` calls.
 */
const notImplemented = (method: string) => (): never => {
  throw new Error(
    `dataProvider.${method}: no hay ningún recurso registrado todavía en esta fase del proyecto.`,
  );
};

export const dataProvider: DataProvider = {
  getList: notImplemented('getList'),
  getOne: notImplemented('getOne'),
  getMany: notImplemented('getMany'),
  getManyReference: notImplemented('getManyReference'),
  create: notImplemented('create'),
  update: notImplemented('update'),
  updateMany: notImplemented('updateMany'),
  delete: notImplemented('delete'),
  deleteMany: notImplemented('deleteMany'),
};
